import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';

import TextInput from '../TextInput';
import LockCopy from '../LockCopy';

import { purchaseFlowOperations } from '@evdy/web-redux/dist/lib/webPurchase/purchaseFlow';
import { authUserOperations } from '@evdy/web-redux/dist/lib/authUser';

import styles from './ZipcodeForm.module.scss';

const { updateWebleadData, resetWebleadUpdated } = authUserOperations;

const {
  'zipcode-form': zipcodeFormClass,
  'text-input-container': textInputContainerClass
} = styles;

const ZipcodeForm = ({ moveToNextStep }) => {
  const dispatch = useDispatch();

  const { authUser = {}, purchaseFlow = {} } = useSelector(({ authUser, webPurchase }) => ({
    authUser,
    purchaseFlow: webPurchase.purchaseFlow
  }));

  // assign most prioritized user data
  const { data: userData, webleadUpdated } = useMemo(() => {
    return !!authUser?.data?._id ? authUser : purchaseFlow;
  }, [authUser, purchaseFlow]);

  const { _id: userId, address: { zip: userZipcode } = {} } = userData ?? {};

  // after submit, navigate to next step
  useEffect(() => {
    if (webleadUpdated) {
      dispatch(purchaseFlowOperations?.resetUpdateWeblead());
      dispatch(resetWebleadUpdated());
      moveToNextStep();
    }
  }, [dispatch, moveToNextStep, webleadUpdated]);

  const ZipcodeFormSchema = Yup.object().shape({
    zipcode: Yup.string()
      .required('This is required!')
      .matches(/^[0-9]+$/, 'Please enter a valid zipcode')
      .min(5, 'Please enter a valid zipcode')
      .max(5, 'Please enter a valid zipcode')
  });

  const handleSubmit = async e => {
    const updatedUserBody = {
      address: { zip: e?.zipcode },
      eFuneral: {
        lastScreen: {
          flow: 'everdays',
          screen: 'zipcodeForm',
          date: new Date().toISOString()
        }
      }
    };
    if (authUser?.data?._id) {
      dispatch(updateWebleadData(updatedUserBody));
    } else {
      dispatch(purchaseFlowOperations.updateWeblead(userId, updatedUserBody));
    }
  };

  const initialValues = { zipcode: userZipcode || '' };

  return (
    <div className={zipcodeFormClass}>
      <h3>Where would you like the funeral home to be?</h3>
      <h5>We’ll find available funeral home providers in the area of your choice. </h5>
      <Formik
        initialValues={initialValues}
        validationSchema={ZipcodeFormSchema}
        onSubmit={handleSubmit}
        enableReinitialize
        validateOnMount
      >
        {({ dirty, isValid }) => (
          <Form>
            <div className={textInputContainerClass}>
              <TextInput autoFocus name="zipcode" placeholder="Zipcode e.g. 48009" />
            </div>
            <LockCopy copy="Everdays will never sell your personalized data to third parties" />
            <button disabled={!isValid} type="submit">
              Continue
            </button>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default ZipcodeForm;
